import { SeriesTemplateTranslationDto } from "../../dto/series/series-template-translations.dto";
import { SeriesTemplateTranslation } from "../../models/series/series-template.model";

export class SeriesTemplateTranslationMapper {
  public static toModel(dto: SeriesTemplateTranslationDto): SeriesTemplateTranslation {
    return {
      languageId: dto.language_id,
      title: dto.title,
      description: dto.description
    }
  }

  public static toDto(dto: SeriesTemplateTranslation): SeriesTemplateTranslationDto {
    return {
      language_id: dto.languageId,
      title: dto.title,
      description: dto.description
    }
  }
}